import React from 'react';
import Modal from '~/components/ModalNewVehicle';
import { ContainerModal, TitleModal, Divider } from '../../../MapOpportunities/styles';
import InfoPanel from '../../../MapOpportunities/components/MapModalSections/InfoPanel';
import NameValueItem from '../../../MapOpportunities/components/MapModalSections/NameValueItem';
import { SimovsatVehicleAPI } from '~/types';

interface VehicleDetailsProps {
  vehicle: SimovsatVehicleAPI;
  open: boolean;
  onClose: () => void;
}

const isActiveStatus = (status?: string) => status === 'ACTIVE' || status === 'ATIVO';

const VehicleDetails: React.FC<VehicleDetailsProps> = ({ vehicle, open, onClose }) => {
  const formatDate = (dateString?: string | null) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  return (
    <Modal
      onConfirm={onClose}
      onCancel={onClose}
      open={open}
      question={false}
      buttonPositive='Fechar'
    >
      <ContainerModal>
        <TitleModal>Detalhes do Veículo</TitleModal>
        <Divider height={15} />

        <InfoPanel title='Informações Básicas'>
          <NameValueItem title='ID'>{vehicle.id || 'N/A'}</NameValueItem>
          <NameValueItem title='Placa'>{vehicle.license_plate || 'N/A'}</NameValueItem>
          <NameValueItem title='Modelo'>{vehicle.model || 'N/A'}</NameValueItem>
          <NameValueItem title='Nome'>{vehicle.name || 'N/A'}</NameValueItem>
          <NameValueItem title='Proprietário do objeto'>{vehicle.object_owner || 'N/A'}</NameValueItem>
          <NameValueItem title='Status'>{isActiveStatus(vehicle.status) ? 'Ativo' : 'Inativo'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Localização'>
          <NameValueItem title='Latitude'>{vehicle.latitude ?? 'N/A'}</NameValueItem>
          <NameValueItem title='Longitude'>{vehicle.longitude ?? 'N/A'}</NameValueItem>
          <NameValueItem title='Última posição'>{formatDate(vehicle.lastPosition)}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Identificação'>
          <NameValueItem title='VIN/Chassi'>{vehicle.vin || 'N/A'}</NameValueItem>
          <NameValueItem title='IMEI'>{vehicle.imei || 'N/A'}</NameValueItem>
          <NameValueItem title='Registro'>{vehicle.registration_number || 'N/A'}</NameValueItem>
          <NameValueItem title='SIM'>{vehicle.sim_number || 'N/A'}</NameValueItem>
          <NameValueItem title='ID Traccar'>{vehicle.traccar_device_id || 'N/A'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Informações Adicionais'>
          <NameValueItem title='Dispositivo'>{vehicle.device_model || vehicle.manufacture || 'N/A'}</NameValueItem>
          <NameValueItem title='Instalação'>{formatDate(vehicle.installation_date)}</NameValueItem>
          <NameValueItem title='Expiração'>{formatDate(vehicle.expiration_date)}</NameValueItem>
          <NameValueItem title='Criado em'>{formatDate(vehicle.created_at)}</NameValueItem>
          <NameValueItem title='Atualizado em'>{formatDate(vehicle.updated_at)}</NameValueItem>
          {vehicle.fipe_data && (
            <NameValueItem title='Dados FIPE'>
              <pre style={{ fontSize: '12px', margin: 0 }}>
                {JSON.stringify(vehicle.fipe_data, null, 2)}
              </pre>
            </NameValueItem>
          )}
        </InfoPanel>
      </ContainerModal>
    </Modal>
  );
};

export default VehicleDetails;
